// @mui
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// utils

// ----------------------------------------------------------------------

const RenderViewButton = ({ permission, link }) => {
    const permissionArry = useSelector((state) => state.Login.permissionArry);

    const authorize = permissionArry.includes(permission)
    return (
        <>
            {authorize && 
                <Link to={link} className='view-icon'><i className="ri-eye-line font-size-17"></i></Link>
            }

        </>

    );
}
export default (RenderViewButton);
